export { default } from "./SectionHero";
export * from "./SectionHero";
export * from "./SectionHero.model";
